module.exports = __webpack_public_path__ + "images/icon-drag.31ad49ec.svg";